import { format } from "date-fns";

function toInputValue(d: Date | undefined): string {
  return d ? format(d, "yyyy-MM-dd'T'HH:mm") : "";
}

interface NativeDateTimeInputProps {
  value: Date | undefined;
  min?: Date;
  max?: Date;
  onChange: (d: Date | undefined) => void;
  "data-testid"?: string;
}

export function NativeDateTimeInput({
  value,
  min,
  max,
  onChange,
  "data-testid": testId,
}: NativeDateTimeInputProps) {
  return (
    <input
      type="datetime-local"
      data-testid={testId}
      className="absolute inset-0 h-full w-full cursor-pointer text-base opacity-0 md:hidden"
      value={toInputValue(value)}
      min={toInputValue(min)}
      max={toInputValue(max)}
      step={1800}
      onChange={(e) =>
        onChange(e.target.value ? new Date(e.target.value) : undefined)
      }
    />
  );
}
